import { AxonTrack } from '../types/Axon';
import { zendeskCancellationReason } from '../types/gql-op-types';
import { NorthbeamAnalytics } from '../types/NorthbeamAnalytics';
import { RosterOrder } from '../types/Roster';

interface IGTagDataLayer {
  push(...args: any[]): void;
}

interface adaResetArgs {
  greeting: string;
  metaFields: { customername: string; email: string; 'SubCancel-Reason': zendeskCancellationReason };
}

export interface AnalyticsMessage {
  event: string;
  properties: Object;
  options?: SegmentAnalytics.SegmentOpts;
}

export interface FiAnalyticsJS extends SegmentAnalytics.AnalyticsJS {
  off?: (event: string, fn: Function) => void;
}

export interface IWindow extends Window {
  recurly: any;
  fbq?: any;
  /**
   * Agentio pixel for CTC attribution
   */
  initAgentioPixel?: (pixelId: string) => void;
  agentioConversionHandler?: (detail: { detail: { conversionType: string; value?: number } }) => void;
  /**
   * Northbeam marketing platform pixel
   */
  Northbeam?: NorthbeamAnalytics;

  analytics?: FiAnalyticsJS;

  axon?: AxonTrack;

  /**
   * Vibe (vibe.co) pixel for TV ad attribution. Loaded via the base snippet in index.html.
   */
  vbpx?: (command: string, ...args: any[]) => void;

  /**
   * Podscribe pixel for podcast attribution. Defined in index.html, which queues events until
   * the tag has loaded and initialized, so callers never touch window.podscribe directly.
   */
  fiPodscribe?: (action: string, params?: Record<string, string | number | undefined>) => void;

  /**
   * Roster pixel for creator/affiliate attribution. Defined in index.html, which queues orders
   * until sa.js has loaded, so callers never touch the $attribution global directly.
   */
  fiRosterOrder?: (order: RosterOrder) => void;

  /** Runs a callback once OneTrust targeting consent (C0004) resolves; defined in index.html. */
  onTargetingConsent?: (callback: () => void) => void;

  dataLayer?: IGTagDataLayer;

  letterpress?(...args: any[]): void;

  ApplePaySession?: typeof ApplePaySession;

  hj?: typeof HotJar.hj;

  // ada.cx is our CX chat provider, embedded via Google Tag Manager (https://tagmanager.google.com/#/container/accounts/4701326477/containers/11191378/workspaces/139/tags/32)
  adaEmbed?: {
    toggle(): void;
    reset(args: adaResetArgs): () => void;
  };

  // Decagon chat widget
  duet?: {
    setUserId: (id: string) => void;
    setUserIdAuth?: (signature: string, epoch: number) => void;
    setMetadata: (metadata: Record<string, any>) => void;
  };
}

export const typedWindow: IWindow = window;
